var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3 p-4 pb-4 mb-5",attrs:{"id":"regBasic"}},[(_vm.userLoginMessage.submit_store_id>0)?_c('progress-bar',{staticClass:"mb-4",on:{"changeStep":_vm.changeStep}}):_vm._e(),_c('router-view',{on:{"saveInfo":_vm.saveInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }